import React, { useEffect, useRef } from 'react';

import { ensureTrustpilotBootstrap } from './ensureTrustpilotBootstrap';

const BUSINESS_UNIT_ID = '60c847b7f033d300019ff3a1';
const TEMPLATE_ID = '54197383fd9dceac42a68694';
const TOKEN = 'd1898377-1875-4f63-87ac-752f7310015d';

/**
 * Trustpilot 官方 TrustBox：Flex（与 Get code 导出一致）
 * bootstrap 由组件内部加载，页面无需再写 script
 */
const TrustpilotFlexTrustScore: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let cancelled = false;

    ensureTrustpilotBootstrap()
      .then(() => {
        if (!cancelled && ref.current && window.Trustpilot) {
          window.Trustpilot.loadFromElement(ref.current, true);
        }
      })
      .catch(() => {
        // bootstrap 加载失败时保留占位链接，不阻断页面
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id={TEMPLATE_ID}
      data-businessunit-id={BUSINESS_UNIT_ID}
      data-style-width="100%"
      data-style-size="XL"
      data-token={TOKEN}
      data-review-languages="en"
      data-text-color="dark"
      data-headline="word"
      data-support-text="review-number"
      data-use-category-icon="true"
      data-use-category-name="true"
      data-background="light"
      data-external-elements-color="dark">
      <a
        href="https://www.trustpilot.com/review/wukongsch.com"
        target="_blank"
        rel="noopener">
        Trustpilot
      </a>
    </div>
  );
};

export default TrustpilotFlexTrustScore;
